import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

const SendSchema = z.object({
  match_id: z.string().trim().min(1).max(80),
  session_id: z.string().trim().min(4).max(80),
  author_name: z.string().trim().min(1).max(60),
  content: z.string().trim().min(1).max(280),
});

export const sendCommunityMessage = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => SendSchema.parse(input))
  .handler(async ({ data }) => {
    const { error } = await supabaseAdmin.from("community_chat_messages").insert({
      match_id: data.match_id,
      session_id: data.session_id,
      author_name: data.author_name,
      content: data.content,
    });
    if (error) {
      console.error("[community] send failed", error);
      return { ok: false as const, error: error.message };
    }
    return { ok: true as const };
  });

const MessageActionSchema = z.object({
  message_id: z.string().uuid(),
});

export const likeCommunityMessage = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => MessageActionSchema.parse(input))
  .handler(async ({ data }) => {
    const { data: row, error: readErr } = await supabaseAdmin
      .from("community_chat_messages")
      .select("like_count")
      .eq("id", data.message_id)
      .maybeSingle();
    if (readErr || !row) return { ok: false as const, error: readErr?.message ?? "not_found" };
    const { error } = await supabaseAdmin
      .from("community_chat_messages")
      .update({ like_count: (row.like_count ?? 0) + 1 })
      .eq("id", data.message_id);
    if (error) return { ok: false as const, error: error.message };
    return { ok: true as const };
  });

export const reportCommunityMessage = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => MessageActionSchema.parse(input))
  .handler(async ({ data }) => {
    const { data: row, error: readErr } = await supabaseAdmin
      .from("community_chat_messages")
      .select("report_count")
      .eq("id", data.message_id)
      .maybeSingle();
    if (readErr || !row) return { ok: false as const, error: readErr?.message ?? "not_found" };
    const { error } = await supabaseAdmin
      .from("community_chat_messages")
      .update({ report_count: (row.report_count ?? 0) + 1 })
      .eq("id", data.message_id);
    if (error) return { ok: false as const, error: error.message };
    return { ok: true as const };
  });